<!-- This view is also used by Accounts/Employee/Reminders -->
<!-- Make sure to check that page as well when making edits -->

<!-- Modals -->
<app-deprecated-modal-form
    #createModal
    [form]="createForm"
    (save)="onCreate(createForm.reminder, createForm)"
    headerText="{{ 'account.addReminder' | translate }}"
>
    <app-form-reminder #createForm></app-form-reminder>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editModal
    [form]="editForm"
    (save)="onCreate(editForm.reminder)"
    headerText="{{ 'account.editReminder' | translate }}"
>
    <app-form-reminder #editForm></app-form-reminder>
</app-deprecated-modal-form>

<app-deprecated-modal #viewModal>
    <ng-container *ngIf="selectedReminder">
        <h1 class="ui header" style="text-align: left">{{ selectedReminder?.subject }}</h1>
        <div style="text-align: left; white-space: pre-wrap" [innerHTML]="selectedReminder.body | sanitizeHtml"></div>
        <h4 style="text-align: left">
            {{ 'account.remindOn' | translate | i18nLabel }} {{ selectedReminder?.remindAt | appDate: 'mediumDate' }}
        </h4>
        <h4 style="text-align: left">
            {{ 'account.repeats' | translate | i18nLabel }}
            {{ selectedReminder?.repeatOn || ('account.never' | translate) }}
        </h4>
        <h4 style="text-align: left">
            {{ 'account.createdOn' | translate | i18nLabel }} {{ selectedReminder?.createdAt | appDate: 'mediumDate' }}
        </h4>
    </ng-container>
</app-deprecated-modal>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    description="{{ 'account.doYouWantToDeleteThisReminder' | translate }}"
    label="{{ 'delete' | translate }}"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'account.employeeProfile' | translate }}" [menuService]="tabMenuService">
        <div class="buttons">
            <ui-button (click)="createModal.show()" type="primary">
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                <span>{{ 'account.createReminder' | translate }}</span>
            </ui-button>
        </div>
    </app-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            <app-table
                [table]="table"
                class="table"
                (rowClicked)="onSelect($event); viewModal.show()"
                (menuItemSelected)="menuAction($event)"
            >
                <app-empty-state
                    label="{{ !table.hasFiltersApplied() ? 'account.noRemindersToDisplay' : '' }}"
                    src="/assets/illustrations/documents.png"
                ></app-empty-state>
            </app-table>
        </div>
    </div>
</div>
